<template>
	<div
		class="review-box-list-item"
		@click="showReviewModal()"
	>
		<ReviewBoxHeader
			class="review-box-list-item__header"
			:review="review"
		/>
		<BaseModal
			ref="modalRef"
			class="review-box-modal"
			header-title="Bewertung"
			with-open-button
			:open-button-props="{ label: 'Mehr lesen', withIcon: false, class: 'review-box-list-item__button' }"
			@open="emit('show-detail-review')"
		>
			<ReviewBoxModalContent :review="review" />
		</BaseModal>
	</div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import ReviewBoxHeader from './internals/ReviewBoxHeader.vue';
import ReviewBoxModalContent from './internals/ReviewModalContent.vue';
import type { ReviewType } from '@/interfaces/review-types';

interface Props {
	review: ReviewType;
}

defineProps<Props>();
const emit = defineEmits(['show-detail-review']);

const modalRef = ref<typeof BaseModal | null>(null);

const showReviewModal = () => {
	emit('show-detail-review');
	modalRef.value?.openModal();
};
</script>

<style lang="scss" scoped>
.review-box-list-item {
	cursor: pointer;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	padding: 1.6rem;
	border: 0.1rem solid $color-primary-l4;
	border-radius: $border-radius-large;
	font-family: $font-family;
	font-size: $font-small-2;
	transition: box-shadow 0.25s ease-out;
	background-color: $color-white;

	& > * {
		margin: 0;
		padding: 0;
	}

	&__button {
		margin-top: 0.4rem;
	}
}
</style>
